import { Box, Divider, Typography } from "@mui/material";

export const PriceCard = ({ row }) => {
	return (
		<Box
			sx={
				{
					// maxWidth: 400,
					// ml: "auto",
					// p: 1,
					// fontSize: "0.95rem",
				}
			}
		>
			{/* Subtotal */}
			<Box display="flex" justifyContent="space-between">
				<Typography
					sx={{
						minWidth: { xs: "auto", sm: 120 },
						fontWeight: 500,
						mr: 1,
					}}
				>
					Subtotal:
				</Typography>
				<Typography component="p" variant="body2">
					₹{row.total_excl_tax}
				</Typography>
			</Box>
			{/* Shipping Charge */}
			<Box display="flex" justifyContent="space-between">
				<Typography
					sx={{
						minWidth: { xs: "auto", sm: 120 },
						fontWeight: 500,
						mr: 1,
					}}
				>
					Delivery Fee:
				</Typography>
				<Box textAlign="right">
					<Box
						display="flex"
						alignItems="center"
						gap={1}
						justifyContent="flex-end"
					>
						{row.total_shipping_charge < row.shipping_charge && (
							<Typography
								sx={{
									color: "#d32f2f",
									textDecoration: "line-through",
									fontWeight: "bold",
									fontSize: "0.9rem",
								}}
							>
								₹{row.shipping_charge.toFixed(2)}
							</Typography>
						)}
						<Typography component="p" variant="body2">
							₹{row.total_shipping_charge.toFixed(2)}
						</Typography>
					</Box>
				</Box>
			</Box>

			{/* {row.partners.map((partner, i) => (
				<Box
					display="flex"
					key={`price-partner-${i}`}
					justifyContent="space-between"
				>
					<Typography variant="caption" sx={{ pl: 1 }}>
						{partner.partner_name}
					</Typography>
					<Box textAlign="right" pr={2}>
						<Box
							display="flex"
							alignItems="center"
							gap={1}
							justifyContent="flex-end"
						>
							{parseInt(partner.shipping_fee) <
								partner.charges && (
								<Typography
									variant="caption"
									sx={{
										color: "#d32f2f",
										textDecoration: "line-through",
									}}
								>
									₹{partner.charges.toFixed(2)}
								</Typography>
							)}
							<Typography variant="caption">
								₹{parseFloat(partner.shipping_fee).toFixed(2)}
							</Typography>
						</Box>
					</Box>
				</Box>
			))} */}

			{/* Platform Charge */}
			<Box display="flex" justifyContent="space-between" >
				<Typography
					sx={{
						minWidth: { xs: "auto", sm: 120 },
						fontWeight: 500,
						mr: 1,
					}}
				>
					Other Seller Fee:
				</Typography>
				<Typography component="p" variant="body2">
					₹{row.platform_fee}
				</Typography>
			</Box>

			{row?.is_cod && <Box display="flex" justifyContent="space-between" mb={1}>
				<Typography
					sx={{
						minWidth: { xs: "auto", sm: 120 },
						fontWeight: 500,
						mr: 1,
					}}
				>
					COD Fee:
				</Typography>
				<Typography component="p" variant="body2">
					₹{row.total_cod_fee}
				</Typography>
			</Box>}

			{/* Grand Total */}
			<Divider />
			<Box display="flex" justifyContent="space-between">
				<Typography
					sx={{
						minWidth: { xs: "auto", sm: 120 },
						fontWeight: 500,
						mr: 1,
					}}
				>
					Total:
				</Typography>
				<Typography component="p" variant="body2">
					₹{row.total_incl_tax}
				</Typography>
			</Box>
		</Box>
	);
};
